import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	primaryNavigationSectionScreenReader: {
		id: 'navigation.global-side-navigation.primary-navigation-section-screen-reader',
		description:
			'Section label used to describe the primary navigation section for screen reader users.',
		defaultMessage: 'Dragging {item} over primary navigation group',
	},
	shortcutsSectionScreenReader: {
		id: 'navigation.global-side-navigation.shortcuts-section-screen-reader',
		description: 'Section label used to describe the shortcuts section for screen reader users.',
		defaultMessage: 'Dragging {item} over shortcuts group',
	},
	hideFromSidebarSectionScreenReader: {
		id: 'navigation.global-side-navigation.hide-from-sidebar-section-screen-reader',
		description:
			'Section label used to describe the hide from sidebar button for screen reader users.',
		defaultMessage: 'Dragging {item} over "Hide from navigation" drop area',
	},
	showInSidebarSectionScreenReader: {
		id: 'navigation.global-side-navigation.show-in-sidebar-section-screen-reader',
		description:
			'Section label used to describe the show in sidebar button for screen reader users.',
		defaultMessage: 'Dragging {item} over "Show in navigation" drop area',
	},
});
